// Setup the amplify front-end environment...
import Amplify from '@aws-amplify/core';
import awsconfig from '../aws-exports';
Amplify.configure(awsconfig);
